import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ShiftJsonDate } from '@qaroni-app/work-calendar/types/schedule';
import { ScheduleSourceEnum } from '@qaroni-app/work-calendar/types/schedule-source.enum';
import { ScheduleTypeEnum } from '@qaroni-app/work-calendar/types/schedule-type.enum';
import { DaysEnum } from '@qaroni-core/types/date/days.enum';
import { CalendarColor } from '@qaroni-shared/types/calendar-color';
import {
  CalendarOverlayData,
  DAY_EVENT_DATA,
} from '@qaroni-shared/types/calendar-overlay-data';

@Component({
  selector: 'qaroni-calendar-day-details-dialog',
  templateUrl: './calendar-day-details-dialog.component.html',
  styleUrl: './calendar-day-details-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class CalendarDayDetailsDialogComponent {
  data = inject<CalendarOverlayData>(DAY_EVENT_DATA);

  public get hasEvents(): boolean {
    return (
      this.data.holidays?.length > 0 ||
      this.data.absences?.length > 0 ||
      this.data.shifts?.length > 0 ||
      this.data.adminSchedules?.length > 0
    );
  }

  public hasShift(shift: ShiftJsonDate) {
    return (
      shift.source === ScheduleSourceEnum.MANUAL &&
      shift.type === ScheduleTypeEnum.SHIFT
    );
  }

  public hasFixed(shift: ShiftJsonDate) {
    return (
      shift.source === ScheduleSourceEnum.WORK_SCHEDULE &&
      shift.type === ScheduleTypeEnum.FIXED
    );
  }

  public hasFlexible(shift: ShiftJsonDate) {
    return (
      shift.source === ScheduleSourceEnum.WORK_SCHEDULE &&
      shift.type === ScheduleTypeEnum.FLEXIBLE
    );
  }

  public iconType(shift: ShiftJsonDate) {
    if (this.hasShift(shift)) {
      return `shift_lock`;
    } else if (this.hasFixed(shift)) {
      return `lock_clock`;
    } else if (this.hasFlexible(shift)) {
      return `calendar_clock`;
    }

    return `do_not_disturb_on`;
  }

  public text(name: string) {
    return name ? name : $localize`Turno Asignado`;
  }

  public getDateEnum(value: string): DaysEnum {
    return value as DaysEnum;
  }

  public getHolidayColorClasses(color: string): string {
    return CalendarColor.getColorClasses(color);
  }

  public getAbsenceColorClasses(color: string): string {
    return CalendarColor.getColorClasses(color, 'absence');
  }
}
